module.exports = __webpack_public_path__ + "img/001-ui-design.21cab2af.svg";